import { cn } from "../../../../helpers";
import CreateSignature from "../CreateSignature/CreateSignature";
import SavedSignatures from "../SavedSignatures/SavedSignatures";
import styles from "./EmailSignatures.module.scss";

export default function EmailSignatures() {
    return (
        <div className={cn("v2-page", styles.container)}>
            <CreateSignature />
            <SavedSignatures />
        </div>
    );
}
